export default function _searchFilters() {
    // console.log('geoform');
    // Check if the module exists before doing anything
    const searchFiltersComponentExists =
        !!document.querySelector('.search-filters');

    // If the module exists, do whatever we need to
    if (searchFiltersComponentExists) {
        // Your code here
        console.log('search filters custom JS');
    }
}
_searchFilters();
